<template>
  <!-- 区域下拉组件 -->
  <el-select
    ref="areaTree"
    @clear="areaTreeClear"
    v-model="areaName"
    :placeholder="placeholder"
    style="width: 100%;"
    clearable
  >
    <el-input
      v-model="areaNameFilter"
      class="areaNameFilter"
      placeholder="输入关键字进行过滤"
      clearable
    ></el-input>
    <el-option :value="areaName" :label="areaName">
      <el-tree
        ref="tree"
        node-key="id"
        :data="areaList"
        :props="areaTreeProps"
        :filter-node-method="areaTreeFilter"
        @node-click="areaTreeClick"
      >
      </el-tree>
    </el-option>
  </el-select>
</template>

<script>

import { getAreaTreeApi } from '@/api/call-system/video';
export default {
  props: {
    projectId: {
      type: String,
     
    },
    areaId: {
      type: String,
    },
    areaName:{
      type: String,
    },
    placeholder: {
      type: String,
      default: '区域名称',
    },
  },
  data() {
    return {
      areaList: [], // 区域列表
      areaNameFilter: '', // 区域名称-过滤关键字
      areaName: '', // 匹配到的区域名称
      areaTreeProps: {
        label: 'title',
        value: 'id',
        children: 'children',
      },
    };
  },
  watch: {
    projectId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.getAreaList();
        } else {
          console.log("*****")
          this.areaTreeClear();
        }
      },
    },
    areaNameFilter(val) {
      this.$refs.tree.filter(val);
    },
    areaId(val) {
      // 如果areaId置空，则清空areaName
      if (!val) {
        this.areaName = '';
      }
    },
  },
  methods: {
    /* 查找树形结构里指定id的节点 */
    findItemById(tree, id) {
      for (let i = 0; i < tree.length; i++) {
        let node = tree[i];
        if (node.id === id) {
          return node;
        }
        if (node.children && node.children.length > 0) {
          let foundItem = this.findItemById(node.children, id);
          if (foundItem) {
            return foundItem;
          }
        }
      }
      return null;
    },
    getAreaList() {
      getAreaTreeApi({ projectId: this.projectId }).then((res) => {
        this.areaList = res.data;
        // 如果areaId不为空，则需要查找到对应的areaName
        if (this.areaId) {
          let item = this.findItemById(this.areaList, this.areaId);
          if (item) {
            this.areaName = item.title;
          }
        }
      });
    },
    areaTreeFilter(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    areaTreeClear() {
      this.areaName = '';
      this.$emit('update:areaId', '');
      this.$emit('update:areaName', '');
    },
    areaTreeClick(node) {
      if (node.nodeType == 1) {
        return;
      } else {
        this.areaName = node.title;
        this.$emit('update:areaId', node.id);
        this.$emit('update:areaName', node.title);
        this.$refs.areaTree.blur();
        this.areaNameFilter = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .areaNameFilter .el-input__inner {
  border-color: #dcdfe6;
}
</style>
